import * as Types from './type';
import modalApi from '../../apis/api/modal';

const actSetExploreModal = (data) => ({
  type: Types.SET_EXPLORE_MODAL,
  data,
});

export const actSetIsShowExploreModal = (data) => ({
  type: Types.SET_IS_SHOW_EXPLORE_MODAL,
  data,
});

export const actSetIsShowExpandAmenity = (data) => ({
  type: Types.SET_IS_SHOW_EXPAND_AMENITY,
  data,
});

export const actSetIsShowAmenityVirtualTour = (data) => ({
  type: Types.SET_IS_SHOW_AMENITY_VIRTUAL_TOUR,
  data,
});

export const reqSetExploreModal = (id) => (dispatch) => {
  if (!id) return;

  return modalApi.getModalDetail(id).then((data) => {
    dispatch(actSetExploreModal(data));
  });
};

export const reqSetIsShowExploreModal = (data) => (dispatch) => {
  return dispatch(actSetIsShowExploreModal(data));
};

export const reqSetIsShowExpandAmenity = (data) => (dispatch) => {
  return dispatch(actSetIsShowExpandAmenity(data));
};

export const reqSetIsShowAmenityVirtualTour = (data) => (dispatch) => {
  return dispatch(actSetIsShowAmenityVirtualTour(data))
}
